// extracted by mini-css-extract-plugin
export default {"resourceItems":"ResourcesSection_resourceItems__9ikvk"};